import * as ActionType from '../../core/ActionType';
import * as Constants from '../../utils/constants';
import { ApiCallBeginAction } from '../api/Action';
import { setErrorResponse, setSuccessResponse } from '../responses/Action';
import { CodeService } from './Service';
import { formatarValorReal, formatarValorNormal } from '../../utils/utils'

import {reset} from 'redux-form';




export const readerCodeResponse = codeObject => ({
    type: ActionType.READER_CODE_RESPONSE,
    codeObject,
});

export function clearAction() {
    return async function (dispatch) {
        await dispatch(reset('FormCode'));
        await dispatch(setSuccessResponse(null));
        await dispatch(setErrorResponse(null));
    }
}

export function readerCodeAction(code) {
    return async function (dispatch) {

        await dispatch(setSuccessResponse(null));
        await dispatch(setErrorResponse(null));
        await dispatch(ApiCallBeginAction());

        try {

            let codeObject = await CodeService.readBarCode(code);

            console.log(codeObject);
            
            await dispatch(setSuccessResponse(`${Constants.DESCRICAO_SUCCESS_TO_PRINTER} Peso de Saída: ${formatarValorNormal(codeObject.peso_saida)} Kg`));
            await dispatch(readerCodeResponse(codeObject));
            

            return codeObject;
        } catch (error) {
            dispatch(setErrorResponse(error));
            throw error;
        }
    }
}